import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import styled, { useTheme } from 'styled-components';

import { Flex, Modal, Tabs, Text } from 'src/packages/core';
import { CheckedIcon } from 'src/packages/icons';
import { Locale } from '../Header.types';

const LanguageCurrencyItemWrapper = styled.div<{ minWidth: string }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-width: ${(props) => props.minWidth ?? 'unset'};

  &:hover {
    cursor: pointer;
    background-color: ${(props) => props.theme.colors.background.secondary.BG4};

    * {
      cursor: pointer !important;
    }
  }
`;

interface LanguagesModalProps {
  isOpen: boolean;
  onClose: () => void;
  locale: Locale;
}

export const LanguagesModal = ({ isOpen, onClose, locale }: LanguagesModalProps) => {
  const { languages, currencies, language, currency, changeSettings } = locale;
  const { t } = useTranslation();
  const theme = useTheme();

  const LanguagesTab = useMemo(() => {
    return (
      <Flex width={'100%'} flexDirection={'column'} overflow={'scroll'} maxHeight={'250px'}>
        {languages.map((item, index) => {
          return (
            <LanguageCurrencyItemWrapper
              key={index}
              minWidth={'120px'}
              onClick={() => {
                changeSettings && changeSettings('lang', item.value);
              }}
            >
              <Text variant={'p1'} text={item.label as string} />
              {language === item.value && <CheckedIcon size={20} />}
            </LanguageCurrencyItemWrapper>
          );
        })}
      </Flex>
    );
  }, [changeSettings, languages, language]);

  const CurrenciesTab = useMemo(() => {
    return (
      <Flex width={'100%'} flexDirection={'column'} overflow={'scroll'} maxHeight={'250px'}>
        {currencies.map((item, index) => {
          const val = item?.value ? item.value.toString() : '';

          return (
            <LanguageCurrencyItemWrapper
              key={index}
              minWidth={'60px'}
              onClick={() => {
                changeSettings && changeSettings('unit', val.toLowerCase());
              }}
            >
              <Text variant={'p1'} text={item.label as string} />
              {currency === val.toLowerCase() && <CheckedIcon size={20} />}
            </LanguageCurrencyItemWrapper>
          );
        })}
      </Flex>
    );
  }, [changeSettings, currencies, currency]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} size='full-screen'>
      <Flex
        width={'100%'}
        position={'absolute'}
        top={'48px'}
        left={'0'}
        right={'0'}
        borderTop={`1px solid ${theme.colors.border.lighter}`}
      />
      <Flex width={'100%'} mt={12} pt={5}>
        <Tabs
          tabsList={[t('language'), t('currency')]}
          tabsChildern={[LanguagesTab, CurrenciesTab]}
        />
      </Flex>
    </Modal>
  );
};
